import React from 'react';

import { Button } from '@change/ds-core-ui';
import { TrashIcon } from '@change/ds-icons';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import type { MediaHitEmbed } from '../../shared/context/types';

import { DeleteMediaModal } from './components/DeleteMediaModal';
import { useDeleteMediaHit } from './hooks/useDeleteMediaHit';

type DeleteMediaHitProps = {
	media: MediaHitEmbed;
	removeMedia: (mediaId: string) => void;
};

export function GammaDeleteMediaHit({ media, removeMedia }: DeleteMediaHitProps): React.JSX.Element | null {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { canDeleteMediaHit, isModalOpen },
		actions: { handleDeleteClick, handleModalResult, setIsModalOpen },
	} = useDeleteMediaHit(media, removeMedia);

	if (!canDeleteMediaHit) return null;

	return (
		<>
			<Button
				size="small"
				iconOnly
				leadingIcon={<TrashIcon />}
				variant="secondary"
				aria-label={`delete media from ${media.url}`}
				data-testid={`media-hit-${media.id}-delete-button`}
				data-qa={`media-hit-${media.id}-delete-button`}
				className="border-none bg-fill-inverse-weak p-2 hover:bg-black/10"
				onClick={handleDeleteClick}
			/>
			{isModalOpen && (
				<DeleteMediaModal
					isOpen={isModalOpen}
					onOpenChange={setIsModalOpen}
					media={media}
					petitionId={petitionId}
					onResult={handleModalResult}
				/>
			)}
		</>
	);
}
